var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDevices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "devices",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_22",
    "data-name": "Ellipse 22",
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#2389d0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "devices-2",
    "data-name": "devices",
    d: "M3.333,7.667h15V6h-15A1.672,1.672,0,0,0,1.667,7.667v9.167H0v2.5H11.667v-2.5H3.333ZM19.167,9.333h-5a.836.836,0,0,0-.833.833V18.5a.836.836,0,0,0,.833.833h5A.836.836,0,0,0,20,18.5V10.167A.836.836,0,0,0,19.167,9.333Zm-.833,7.5H15V11h3.333Z",
    transform: "translate(10.062 8)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevices);
export default __webpack_public_path__ + "static/media/devices.e3499a6d9c54e442bb2e8ef4f976b15e.svg";
export { ForwardRef as ReactComponent };